
        Component.define('imprensa', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

$('.posts-filter').on('change', function() {
    const media     = $('#post-media select').val();
    const year      = $('#post-year select').val();
    const $postlist = $('.post-list');
    const $postitem = $postlist.find('.post-item');

    if (media === '' && year === '') {
        $postitem.show();
    } else {
        if(media !== '' && year !== '') {
            $postitem.hide();
            $postlist.find('.media-' + media + '.year-' + year).show();
        } else {
            $postitem.hide();
            if (media !== '') {
                $postlist.find('.media-' + media).show();
            }

            if (year !== '') {
                $postlist.find('.year-' + year).show();
            }
        }
    }
});

$('.post-list').find('a').on('click', function() {
    const $this = $(this);

    $.getJSON(root + '/imprensa/?id=' + $this.attr('data-id'), function(data) {
        if (data.type === 'post') {
            $('.post-image').show();
            $('.videoWrap').hide();
            $('.post-image').attr('src', 'assets/images/covers/' + data.cover);
        } else if (data.type === 'video') {
            $('.videoWrap').show();
            $('.post-image').hide();
            $('.videoWrapper').html('<iframe width="100%" height="315" src="https://www.youtube.com/embed/' + data.video + '" frameborder="0" allowfullscreen></iframe>');
        }

        $('.post-title').html(data.title);
        $('.post-inner-content').html(data.content);

        const postHeader = '.post-header';
        $(postHeader).find('> div').eqHeight(2);
        Navigation.helpers.scrollTo($('#content-imprensa'));
    });
});


        });